import { PAGES } from '../constants';
import handleMDAInbound from '../actions/handleMDAInbound';

export const routePaths = {
  [PAGES.HOME]: '/',
  [PAGES.INDUSTRY]: '/getquote/industry',
  [PAGES.BUSINESS_INFORMATION]: '/getquote/businessinfo',
  [PAGES.POLICIES]: '/getquote/policyselection',
  [PAGES.FINANCE_BASICS]: '/getquote/financebasics',
  [PAGES.LOCATIONS]: '/getquote/locations',
  [PAGES.GENERAL_LIABILITY]: '/getquote/gl',
  [PAGES.PROFESSIONAL_LIABILITY]: '/getquote/pl',
  [PAGES.ADDITIONAL_INSUREDS]: '/getquote/additional-insureds',
  [PAGES.CONTACT_INFORMATION]: '/getquote/contact',
  [PAGES.ADD_ONS]: '/getquote/addons',
  [PAGES.SUMMARY]: '/getquote/summary',
  [PAGES.PAYMENT]: '/getquote/purchase',
  [PAGES.QUOTEHELP]: '/quotehelp',
  [PAGES.APPLICATION]: '/application/:id',
  [PAGES.ERROR]: '/error',
  [PAGES.MDA_INBOUND]: { path: '/quote', thunk: handleMDAInbound },
};
